import _ from 'underscore';
import { useEffect } from 'react';

export const useDisabledKeynavRegion = ({ ref, disabled }) => {
  useEffect(() => {
    if (!ref || !ref.current || !disabled) {
      return _.noop;
    }
    const disableInternalElements = () => {
      const children = ref.current.querySelectorAll('button,input,a,select,textarea');

      children.forEach((child) => {
        child.setAttribute('tabindex', '-1');
        child.setAttribute('disabled', true);
      });
    };

    const observer = new MutationObserver(disableInternalElements);

    observer.observe(ref.current, {
      childList: true,
      subtree: true,
      attributes: false,
      characterData: false,
    });

    return () => {
      observer.disconnect();
    };
  }, [ref, disabled]);
};
